'use client';
import { FlexRow as SharedFlexRow } from '@launchstore/shared-puck';
import type { FlexRowProps } from '@launchstore/shared-puck';
export const FlexRow: any = SharedFlexRow;
export type { FlexRowProps };
export default FlexRow;
